module.exports = __webpack_public_path__ + "img/TOP.847eb18b.png";